export enum AcceptanceCriteriaStatus {
    NotReviewed = 0,
    ReviewedNotNeeded = 1,
    ReviewedEnabled = 2,
    ReviewedManualNeeded = 3
}

export namespace AcceptanceCriteriaStatus {
    export function toString(): string;
    export function toString(level: AcceptanceCriteriaStatus): string;
    export function toString(level?: AcceptanceCriteriaStatus): string {
        return level !== null
            ? AcceptanceCriteriaStatus[level]
            : Object.prototype.toString.call(AcceptanceCriteriaStatus);
    }

    export function toName(enumValue: AcceptanceCriteriaStatus): string {
        switch (enumValue) {
            case AcceptanceCriteriaStatus.NotReviewed:
                return 'Not Reviewed';
            case AcceptanceCriteriaStatus.ReviewedNotNeeded:
                return 'Reviewed - No Acceptance Criteria Needed at this Level';
            case AcceptanceCriteriaStatus.ReviewedEnabled:
                return 'Reviewed - Enable Acceptance Criteria';
            case AcceptanceCriteriaStatus.ReviewedManualNeeded:
                return 'Reviewed - Manual Review Needed';
        }
    }
}
